module.exports = "<label class=\"custom-field\">\t\n\t<input type=\"checkbox\" name='filtros[]' value=\"{{ id }}\" {% if ativo %}checked{% endif %} />\n\t<span class=\"label-text\">{{ titulo }}</span>\n</label>"


//////////////////
// WEBPACK FOOTER
// ./views/kits/dialog-cardapio/li-filtros.twig
// module id = 45
// module chunks = 0